<script setup lang="ts">
interface AttrBreadcrumbs {
    url: string;
    name: string;
}
interface MyProp {
    component: string;
    url: string;
    name: string;
    attr: Array<AttrBreadcrumbs>;
}

const props = defineProps<{
    attr?: MyProp;
}>(); 
</script>
<template>  
  <div class="flex">
      <nav aria-label="breadcrumb" class="text-gray-500 breadcrumbs">
          <ul class="flex p-0 m-0 list-none">
              <li v-for="(item, index) in props.attr?.attr" :key="index" class="inline-block">
                  <!-- Verifique se é o último item na lista para não adicionar o href -->
                  <a v-if="index < props.attr.attr.length - 1" :href="item.url" class="hover:text-gray-700">{{ item.name }}</a>
                  <!-- Se for o último item, exiba o nome sem o link -->
                  <span v-else>{{ item.name }}</span>
                  <!-- Adicione o separador para todos os itens exceto o último -->
                  <span v-if="index < props.attr.attr.length - 1" class="mx-2">></span>
              </li>
          </ul>
      </nav>
  </div>
  </template>